import { render, staticRenderFns } from "./TeamStore.vue?vue&type=template&id=0177d3aa"
import script from "./TeamStore.vue?vue&type=script&lang=js"
export * from "./TeamStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports